import { render, staticRenderFns } from "./Patterns.vue?vue&type=template&id=6e0f0b2f&"
import script from "./Patterns.vue?vue&type=script&lang=js&"
export * from "./Patterns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports